module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-0ad3fe68.png";